import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMyExp(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Employment History</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                       
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >Jan 2011 - Present (9 yrs 5 mos)</div>
                        <div>Bangalore, India</div>
                    </div>
                    <div >
                        <div className="card-list-header">Executive Vice President</div>
                        <div className="card-list-subheader">Ipsos MMA</div>
                    </div>
                </div>
                <div className="card-description">
                        Build the Analytics Centre of Excellence, head the operational decision making, 
                        manage delivery and quality, capability building, talent management.
                        Build the Analytics Centre of Excellence, head the operational decision making, 
                        manage delivery and quality, capability building, talent management.Build the Analytics Centre of Excellence, head the operational decision making, 
                        manage delivery ...<span className="card-description-more f-right">More...</span>
                    </div> 
                <hr className="mg-r-0" ></hr> 
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >Jan 2011 - Present (9 yrs 5 mos)</div>
                        <div>Bangalore, India</div>
                    </div>
                    <div className="">
                        <div className="card-list-header">Group Manager</div>
                        <div className="card-list-subheader">Symphony Marketing Solutions</div>
                    </div>
                </div>
                <div className="card-description">
                    Pricing, Trade Promotion, Marketing Mix Analytics for CPG and Retail clients, 
                    Analytic Product Development, Loyalty Analytics
                    </div> 
                
                <hr className="mg-r-0" ></hr>
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >Jan 2011 - Present (9 yrs 5 mos)</div>
                        <div>Bangalore, India</div>
                    </div>
                    <div className="">
                        <div className="card-list-header">Assisstant Manager</div>
                        <div className="card-list-subheader">GE Capital International Services</div>
                    </div>
                </div>
                <div className="card-description">
                    Financial Analytics for GE's Private Label Credit Card business. Scorecard Development, 
                    Score Performance Evaluation, Delinquency Forecasts, Portfolio Health Monitoring
                    ...<span className="card-description-more f-right">More...</span>
                </div>                
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyExp